import {useSelector, useDispatch} from 'react-redux'
import {SET_DATA_MODAL_FORM_LIST} from '../../../../../../store/modal/const'

const useShowLoginInfoModal = () => {
  const dispatch = useDispatch()
  const reduxData = useSelector(
    (state) => state.modal.counseling.loginInfoModal,
  )
  const {isOpen, onChange} = reduxData

  const setOpen = (open, onChange = () => {}) => {
    dispatch({
      type: SET_DATA_MODAL_FORM_LIST,
      payload: 'counseling.loginInfoModal',
      data: {
        ...reduxData,
        isOpen: open,
        onChange,
      },
    })
  }

  return {
    isOpen,
    onChange,
    open: (onChange = () => {}) => {
        setOpen(true, onChange)
      },
    close: () => {
      setOpen(false)
    },
    toggle: () => {
      setOpen(!isOpen)
    },
  }
}
export default useShowLoginInfoModal
